import { useEffect, useState, useMemo } from "react";
import { Container, ListGroup, Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { useTitle } from "./context";
import { fetchSpells, storeState, loadState } from "./utilities";
import { AlphabeticalSpellsList } from "./spellsList";

import "bootstrap/dist/css/bootstrap.min.css";


const SPELLS_PAGE_KEY = "spells-page";


export function SpellsPage({navbarHeight}) {
    const navigate = useNavigate();
    const { setTitle } = useTitle();
    const [spells, setSpells] = useState([]);
    const [status, setStatus] = useState("idle"); // idle | loading | success | error
    const [error, setError] = useState("");
    
    useEffect(() => {
        setTitle("Incantesimi");
    }, [setTitle]);
    
    const getStateJson = () => {
        return {
            spells: spells
        };
    };

    const setStateJson = (s) => {
        setSpells(s.spells);
    };
    
    useEffect(() => {
        if (spells && spells.length > 0) {
            storeState(SPELLS_PAGE_KEY, getStateJson());
        }
    }, [spells]);
    
    const fetchData = async () => {
        setSpells(await fetchSpells());
    }

    useEffect(() => {
        let mounted = true;
        (
            async () => {
                try {
                    setStatus("loading");
                    const s = loadState(SPELLS_PAGE_KEY);
                    if (s?.spells?.length > 0) {
                        setStateJson(s);
                    }
                    else {
                        await fetchData();
                    }
                    if (mounted) {
                        setStatus("success");
                    }
                }
                catch {
                    if (mounted) {
                        setError("Failed to load spells.");
                        setStatus("error");
                    }
                }
            }
        )();
        return () => {
            mounted = false;
        };
    }, []);

    const content = useMemo(() => {
        if (status === "loading") {
            return (
                <div className="d-flex justify-content-center py-5">
                    <Spinner animation="border" role="status" aria-label="Loading items" />
                </div>
            );
        }
        if (status === "error") {
            return <Alert variant="danger" className="my-3">{error}</Alert>;
        }
        if (spells.length === 0) {
            return <Alert variant="secondary" className="my-3">No spells found.</Alert>;
        }

        //else

        const spellsListHeight = `calc(100vh - ${navbarHeight}px)`;

        return (
            <AlphabeticalSpellsList
            stateKey={SPELLS_PAGE_KEY}
            spells={spells}
            onSpellClick={(spellId) => navigate(`/spells/${spellId}`)}
            height={spellsListHeight}/>
        );
    }, [spells, error, navigate]);

    const containerMargin = `${navbarHeight}px`;
    const containerHeight = `calc(100vh - ${navbarHeight}px)`;

    return (
        <Container
        fluid
        className="bg-light p-0"
        style={{
            marginTop: containerMargin,
            height: containerHeight,
            overflowY: "auto"
        }}
        >
            {content}
        </Container>
    );
}
